import { ICaseResolutionModel } from '../../../interfaces/ICaseResolutionModel';
import { HttpResponseError } from '../../../interfaces/IHttpResponseError';
import CheckmateApiClient from '../../../services/apiClient';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useSetCasePinned = () => {
    return useMutation({
        mutationFn: async (caseModel: ICaseResolutionModel | undefined) => {
            if (!caseModel) throw new Error('Failed to case update');

            const response = await _apiClient.setCaseResolutionPinned(
                caseModel.id
            );

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error(
                    'Failed to update case'
                );
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
    });
};